import React from "react";

const LifeAtCompanySection= () => {
  return (
    <section className="bg-card dark:text-white py-12 sm:py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 sm:grid-cols-2 gap-8 sm:gap-12 items-center">
          
          {/* Text Section */}
          <div className="space-y-6 sm:space-y-8 order-2 lg:order-1">
            <div className="space-y-3 sm:space-y-4">
              <h6 className="text-lg sm:text-xl font-normal text-blue-400 tracking-tight">
                #LifeAtApexovative
              </h6>
              <p className="text-xl sm:text-2xl font-medium">
                People Who Build the Future
              </p>
              <p className="text-base sm:text-lg max-w-2xl">
                At Apexovative, we empower talented minds to innovate, grow, and create global impact together.
              </p>
            </div>

            {/* Features */}
            <div className="space-y-3 sm:space-y-4">
              {[
                "Learn, evolve, and lead with confidence.",
                "Work in a culture built on respect, openness, and creativity.",
                "Build meaningful products that solve real-world challenges."
              ].map((text, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <div className="flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6 mt-0.5">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 512 512"
                      className="w-3 h-3 text-blue-500"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                    </svg>
                  </div>
                  <p className="text-base sm:text-lg">{text}</p>
                </div>
              ))}
            </div>

            {/* Button */}
            <a
              target="_self"
              href="/about"
              className="inline-flex items-center px-6 sm:px-8 py-3 sm:py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl text-sm sm:text-base"
            >
              Join Our Journey
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 448 512"
                className="w-4 h-4 sm:w-5 sm:h-5 ml-2"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path>
              </svg>
            </a>
          </div>

          {/* Image Section */}
          <div className="flex justify-center lg:justify-end order-1 lg:order-2">
            <div className="relative w-full max-w-sm sm:max-w-md">
              <div className="w-full h-64 sm:h-72 md:h-80 bg-gray-200 rounded-2xl shadow-xl overflow-hidden relative">
                <img
                  alt="Nadcab Family"
                  loading="lazy"
                  decoding="async"
                  src="https://img.nadcab.com/wp-content/uploads/2025/11/nadcab-family.webp?w=3840&q=75"
                  srcSet="
                    https://img.nadcab.com/wp-content/uploads/2025/11/nadcab-family.webp?w=256&q=75 256w,
                    https://img.nadcab.com/wp-content/uploads/2025/11/nadcab-family.webp?w=384&q=75 384w,
                    https://img.nadcab.com/wp-content/uploads/2025/11/nadcab-family.webp?w=640&q=75 640w,
                    https://img.nadcab.com/wp-content/uploads/2025/11/nadcab-family.webp?w=750&q=75 750w,
                    https://img.nadcab.com/wp-content/uploads/2025/11/nadcab-family.webp?w=828&q=75 828w,
                    https://img.nadcab.com/wp-content/uploads/2025/11/nadcab-family.webp?w=1080&q=75 1080w,
                    https://img.nadcab.com/wp-content/uploads/2025/11/nadcab-family.webp?w=1200&q=75 1200w,
                    https://img.nadcab.com/wp-content/uploads/2025/11/nadcab-family.webp?w=1920&q=75 1920w,
                    https://img.nadcab.com/wp-content/uploads/2025/11/nadcab-family.webp?w=2048&q=75 2048w,
                    https://img.nadcab.com/wp-content/uploads/2025/11/nadcab-family.webp?w=3840&q=75 3840w
                  "
                  className="object-cover w-full h-full"
                  style={{ position: "absolute", inset: 0 }}
                />
              </div>

              {/* Badge */}
              <div className="absolute -bottom-3 right-0 sm:-bottom-4 sm:-right-6 md:-bottom-4 md:-right-9 rounded-xl sm:rounded-2xl w-28 sm:w-32 md:w-38 transform rotate-2 p-2 sm:p-3 bg-white/90 dark:bg-gray-800/90 text-black dark:text-white shadow-lg">
                <div className="text-center">
                  <div className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 mx-auto bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 24 24"
                      className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 text-white"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path fill="none" d="M0 0h24v24H0z"></path>
                      <path d="M9.68 13.69 12 11.93l2.31 1.76-.88-2.85L15.75 9h-2.84L12 6.19 11.09 9H8.25l2.31 1.84-.88 2.85zM20 10c0-4.42-3.58-8-8-8s-8 3.58-8 8c0 2.03.76 3.87 2 5.28V23l6-2 6 2v-7.72A7.96 7.96 0 0 0 20 10zm-8-6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6z"></path>
                    </svg>
                  </div>
                  <div className="space-y-1 mt-1 sm:mt-2">
                    <div className="space-y-0.5 sm:space-y-1">
                      <p className="text-[10px] sm:text-xs font-medium">7 Years Experience</p>
                      <p className="text-[10px] sm:text-xs uppercase tracking-wider">Driven by professionals</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default LifeAtCompanySection;
